import { render, staticRenderFns } from "./FilesDialogContent.vue?vue&type=template&id=3cb8b5fe&scoped=true"
import script from "./FilesDialogContent.vue?vue&type=script&lang=js"
export * from "./FilesDialogContent.vue?vue&type=script&lang=js"
import style0 from "./FilesDialogContent.vue?vue&type=style&index=0&id=3cb8b5fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb8b5fe",
  null
  
)

export default component.exports